/**
 * The one-line confirmation above the map bar — "Jumped to Pit · HW 2" —
 * (D-028). A status region, so a screen reader hears the jump the sighted
 * surveyor sees; auto-dismissed, never a control.
 */

import type { ReactNode } from 'react';

export interface ToastProps {
  message: string | null;
}

export function Toast({ message }: ToastProps): ReactNode {
  return (
    <div className={message ? 'toast toast--show' : 'toast'} role="status" aria-live="polite">
      {message ?? ''}
    </div>
  );
}
